import { render, staticRenderFns } from "./DetailVoucherPartner.vue?vue&type=template&id=25f0684c"
import script from "./DetailVoucherPartner.vue?vue&type=script&lang=js"
export * from "./DetailVoucherPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports